/**
 * Pages written whole in each language: the Privacy Policy (/privacy/), the Terms of Service
 * (/terms/) and the guides (/guide/...). Each holds its text in English and in Turkish (kept
 * whole per language, not translated line by line) and shows the one of the page's language;
 * the built /tr/ copy keeps only its own.
 */
import "../i18n/boot";
import { resumeSession } from "../http";
import { lang } from "../i18n";
import { mountNav } from "./nav";

const shown = lang();
for (const doc of document.querySelectorAll<HTMLElement>("[data-lang]"))
  doc.hidden = doc.dataset.lang !== shown;
document.documentElement.lang = shown;

// The header shows the last known session at once, then the real one.
const siteNav = mountNav();
void resumeSession()
  .then((token) => siteNav.setSignedIn(token !== null))
  .catch(() => siteNav.setSignedIn(false));
